module.exports = __webpack_public_path__ + "img/cjcl2.82ad779a.png";